/**
 * Checkout / Add to cart agreement checkboxes
 */
(function () {
  const STORAGE_KEY = 'themeAgreementChecks';

  function getStoredChecks() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}') || {};
    } catch (e) {
      return {};
    }
  }

  function setStoredCheck(id, checked) {
    const stored = getStoredChecks();
    stored[String(id)] = Boolean(checked);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stored));
  }

  function isRequiredCheckbox(input) {
    const value = String(input.getAttribute('data-required') || input.dataset.required || '')
      .trim()
      .toLowerCase();
    return value === 'true' || value === '1';
  }

  function areRequiredChecked(container) {
    if (!container) return true;
    const checkboxes = container.querySelectorAll('[data-agreement-checkbox]');
    const required = Array.from(checkboxes).filter(isRequiredCheckbox);
    if (!required.length) return true;
    return required.every((input) => input.checked);
  }

  function showError(container, show) {
    if (!container) return;
    const error = container.querySelector('[data-agreement-error]');
    container.classList.toggle('agreement-checkboxes--invalid', show);
    if (error) {
      if (show) error.removeAttribute('hidden');
      else error.setAttribute('hidden', '');
    }
  }

  function restoreChecks(root = document) {
    const stored = getStoredChecks();
    root.querySelectorAll('[data-agreement-checkbox]').forEach((input) => {
      const id = input.dataset.agreementId;
      if (id && stored[id]) input.checked = true;
    });
  }

  function syncStoredFromInput(input) {
    const id = input.dataset.agreementId;
    if (!id) return;
    setStoredCheck(id, input.checked);
  }

  function isCartEmptyContext(scope) {
    if (!scope) return false;
    if (scope.id === 'main-cart-footer' && scope.classList.contains('is-empty')) return true;
    if (scope.matches?.('cart-drawer') && scope.classList.contains('is-empty')) return true;
    if (scope.matches?.('cart-items') && scope.classList.contains('is-empty')) return true;

    const drawer = scope.closest?.('cart-drawer');
    if (drawer?.classList.contains('is-empty')) return true;

    const footer = scope.closest?.('#main-cart-footer');
    if (footer?.classList.contains('is-empty')) return true;

    const cartItems = scope.closest?.('cart-items');
    if (cartItems?.classList.contains('is-empty')) return true;

    return false;
  }

  function getPageAgreementContainer() {
    return (
      document.querySelector('.cart-agreements--below-items [data-agreement-checkboxes]') ||
      document.querySelector('#main-cart-footer [data-agreement-checkboxes]') ||
      document.querySelector('form#cart [data-agreement-checkboxes]')
    );
  }

  function setCheckoutLocked(elements, locked, cartEmpty) {
    elements.forEach((button) => {
      if (!(button instanceof HTMLElement)) return;

      if (cartEmpty) {
        button.setAttribute('disabled', 'disabled');
        button.removeAttribute('data-agreement-locked');
        button.removeAttribute('aria-disabled');
        return;
      }

      if (locked) {
        button.setAttribute('disabled', 'disabled');
        button.setAttribute('data-agreement-locked', 'true');
        button.setAttribute('aria-disabled', 'true');
      } else {
        button.removeAttribute('disabled');
        button.removeAttribute('data-agreement-locked');
        button.removeAttribute('aria-disabled');
      }
    });
  }

  function updateCartPageGate() {
    const cartFooter = document.getElementById('main-cart-footer');
    if (!cartFooter) return;

    const checkboxContainer = getPageAgreementContainer();
    const buttons = cartFooter.querySelectorAll('[data-agreement-checkout], .cart__checkout-button');
    if (!buttons.length) return;

    // No agreement UI on page → leave checkout alone (aside from empty cart)
    if (!checkboxContainer) {
      if (!cartFooter.classList.contains('is-empty')) {
        buttons.forEach((button) => {
          if (button.hasAttribute('data-agreement-locked')) {
            button.removeAttribute('disabled');
            button.removeAttribute('data-agreement-locked');
            button.removeAttribute('aria-disabled');
          }
        });
      }
      return;
    }

    const complete = areRequiredChecked(checkboxContainer);
    const cartEmpty = cartFooter.classList.contains('is-empty');

    setCheckoutLocked(buttons, !complete, cartEmpty);

    cartFooter
      .querySelectorAll('.additional-checkout-buttons, .cart__dynamic-checkout-buttons, .shopify-payment-button')
      .forEach((el) => {
        el.classList.toggle('agreement-checkout-locked', !complete && !cartEmpty);
      });
  }

  function updateDrawerGate() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const checkboxContainer = drawer.querySelector('[data-agreement-checkboxes]');
    const buttons = drawer.querySelectorAll('[data-agreement-checkout], .cart__checkout-button');
    if (!checkboxContainer || !buttons.length) return;

    const complete = areRequiredChecked(checkboxContainer);
    const cartEmpty = drawer.classList.contains('is-empty');

    setCheckoutLocked(buttons, !complete, cartEmpty);
  }

  function updateCartGates() {
    updateCartPageGate();
    updateDrawerGate();
  }

  function handleCheckoutAttempt(event) {
    const button = event.target.closest(
      '[name="checkout"], .cart__checkout-button, [data-agreement-checkout]'
    );
    if (!button) return;

    // Disabled buttons should not proceed
    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') {
      event.preventDefault();
      event.stopPropagation();

      const inDrawer = Boolean(button.closest('cart-drawer'));
      const checkboxContainer = inDrawer
        ? button.closest('cart-drawer')?.querySelector('[data-agreement-checkboxes]')
        : getPageAgreementContainer();

      if (checkboxContainer && !areRequiredChecked(checkboxContainer)) {
        showError(checkboxContainer, true);
        checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }

    const inDrawer = Boolean(button.closest('cart-drawer'));
    const checkboxContainer = inDrawer
      ? button.closest('cart-drawer')?.querySelector('[data-agreement-checkboxes]')
      : getPageAgreementContainer();

    if (!checkboxContainer) return;

    if (!areRequiredChecked(checkboxContainer)) {
      event.preventDefault();
      event.stopPropagation();
      showError(checkboxContainer, true);
      checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
      checkboxContainer
        .querySelectorAll('[data-agreement-checkbox]')
        .forEach((input) => {
          if (isRequiredCheckbox(input) && !input.checked) input.focus();
        });
    }
  }

  function handleFormSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    const isCartForm = form.id === 'cart' || form.id === 'CartDrawer-Form';
    if (!isCartForm) return;

    const submitterName = event.submitter?.getAttribute('name');
    // Quantity updates also submit the cart form — only gate checkout
    if (submitterName && submitterName !== 'checkout') return;
    if (!submitterName && !event.submitter?.classList?.contains('cart__checkout-button')) {
      // Native enter-key submit without submitter: treat as checkout only if checkout is the intent
      // Skip gating for ambiguous submits
      return;
    }

    const inDrawer = form.id === 'CartDrawer-Form' || Boolean(form.closest('cart-drawer'));
    const checkboxContainer = inDrawer
      ? document.querySelector('cart-drawer [data-agreement-checkboxes]')
      : getPageAgreementContainer();

    if (!checkboxContainer) return;

    if (!areRequiredChecked(checkboxContainer)) {
      event.preventDefault();
      event.stopPropagation();
      showError(checkboxContainer, true);
      checkboxContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  class AgreementPopup extends HTMLElement {
    connectedCallback() {
      this.confirmButton = this.querySelector('[data-agreement-popup-confirm]');
      this.dialog = this.querySelector('.agreement-popup__dialog');
      this.checkboxContainer = this.querySelector('[data-agreement-checkboxes]');
      this._onConfirm = null;

      this.querySelectorAll('[data-agreement-popup-close]').forEach((el) => {
        el.addEventListener('click', () => this.hide());
      });

      this.confirmButton?.addEventListener('click', () => this.confirm());
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.hide();
      });
    }

    show(onConfirm) {
      this._onConfirm = onConfirm;
      restoreChecks(this);
      showError(this.checkboxContainer, false);
      this.hidden = false;
      document.body.classList.add('overflow-hidden');
      this.dialog?.focus();
      if (typeof trapFocus === 'function' && this.dialog) {
        trapFocus(this, this.dialog);
      }
    }

    hide() {
      this.hidden = true;
      this._onConfirm = null;
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus();
    }

    confirm() {
      if (!areRequiredChecked(this.checkboxContainer)) {
        showError(this.checkboxContainer, true);
        return;
      }

      this.querySelectorAll('[data-agreement-checkbox]').forEach((input) => syncStoredFromInput(input));

      const callback = this._onConfirm;
      this.hide();
      restoreChecks(document);
      updateCartGates();
      if (typeof callback === 'function') callback();
    }
  }

  if (!customElements.get('agreement-popup')) {
    customElements.define('agreement-popup', AgreementPopup);
  }

  let showOnAtc = false;
  let showOnCart = false;
  const configEl = document.getElementById('AgreementConfig');
  if (configEl) {
    try {
      const data = JSON.parse(configEl.textContent);
      showOnAtc = Boolean(data.showOnAtc);
      showOnCart = Boolean(data.showOnCart);
    } catch (e) {
      // ignore invalid config
    }
  }

  window.themeAgreements = {
    get showOnAtc() {
      return showOnAtc;
    },
    get showOnCart() {
      return showOnCart;
    },
    openAtcPopup(onConfirm) {
      const popup = document.getElementById('AgreementPopup');
      if (!popup || typeof popup.show !== 'function') {
        if (typeof onConfirm === 'function') onConfirm();
        return;
      }
      popup.show(onConfirm);
    },
    refresh() {
      restoreChecks(document);
      updateCartGates();
    },
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-agreement-checkbox]');
    if (!input) return;

    syncStoredFromInput(input);

    document
      .querySelectorAll(`[data-agreement-checkbox][data-agreement-id="${input.dataset.agreementId}"]`)
      .forEach((other) => {
        if (other !== input) other.checked = input.checked;
      });

    const container = input.closest('[data-agreement-checkboxes]');
    if (container && areRequiredChecked(container)) showError(container, false);

    updateCartGates();
  });

  document.addEventListener('click', handleCheckoutAttempt, true);
  document.addEventListener('submit', handleFormSubmit, true);

  function initGates() {
    restoreChecks(document);
    updateCartGates();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGates);
  } else {
    initGates();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      setTimeout(() => {
        restoreChecks(document);
        updateCartGates();
      }, 120);
    });
  }

  const drawerRoot = document.querySelector('cart-drawer');
  if (drawerRoot) {
    let debounceTimer;
    const observer = new MutationObserver(() => {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        restoreChecks(drawerRoot);
        updateCartGates();
      }, 50);
    });
    observer.observe(drawerRoot, { childList: true, subtree: true });
  }
})();
